import { Button, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Switch } from '@material-ui/core';
import {
  faBars,
  faChevronLeft,
  faExclamationTriangle,
  faSignOutAlt,
  faLocationCrosshairs,
  faBan,
  faBell,
  faBellSlash
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isMobile, isMobileOnly, isTablet } from 'react-device-detect';
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import Popper from '@material-ui/core/Popper';
import React, { useEffect, useRef, useState } from 'react';
import { genKey, getStorage, setStorage } from "components/utils/Storage";

import { SvgIcon } from '../utils/SvgIcon';
import LeftPanel from './LeftPanel';
import MyButton from '../form/MyButton';

import logoSanef from '../../images/logo.png';
import packageJson from '../../../package.json';
import usePosition from '../../hooks/usePosition.js';
import { REMOVE_MESSAGE, UPDATE_USER_POSITION } from '../../constants/constants';

const Header = (props) => {
  const { logout } = props;
  const history = useHistory();
  const location = useLocation();
  const [showLeftPanel, setShowLeftPanel] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const anchorRef = useRef(null);
  const prevOpen = useRef(showSubMenu);
  const auth = useSelector(state => state["authentification"]);
  let initialSoundNotif = getStorage(genKey("soundNotif"));
  initialSoundNotif = (initialSoundNotif==null)?false:initialSoundNotif;
  const [soundNotif, setSoundNotif] = useState(initialSoundNotif);
  let initialGeoloc = getStorage(genKey("geoloc"));
  initialGeoloc = (initialGeoloc==null)?false:initialGeoloc;
  console.log(initialGeoloc);
  const [geoloc, setGeoloc] = useState(initialGeoloc);
  const { startWatchPosition, stopWatchPosition } = usePosition();

  useEffect(() => {
    if (initialGeoloc) {
      startWatchPosition();
    }
  }, []);

  const handleToggle = () => {
    setShowSubMenu((prevOpen) => !prevOpen);
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setShowSubMenu(false);
  };
  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setShowSubMenu(false);
    }
  };

  const handleLogout = () => {
    logout();
  }
  const handleSwitchSoundNotif = () => {
    setStorage(genKey("soundNotif"), !soundNotif);
    setSoundNotif(!soundNotif);
  };

  const handleSwitchGeoloc = () => {
    const newgeoloc = !geoloc;
    if (newgeoloc) {
      startWatchPosition();
    } else {
      stopWatchPosition();
    }
    setStorage(genKey("geoloc"), newgeoloc);
    setGeoloc(newgeoloc);
  };

  useEffect(() => {
    if (prevOpen.current === true && showSubMenu === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = showSubMenu;
  }, [showSubMenu]);

  if (isMobile) {
    return (
      <div id="topbar">

        <div id="burger-menu">
          {location && !location.pathname.includes('/equipement/') &&
            <MyButton className="classic-button" type="button" href="#" iconCenter={{ icon: faBars, type: 'fontAwesome' }}
              styleCss={{ boxShadow: 'none', color: '#FFFFFF', backgroundColor: '#0094ca', width: '20px', height: '20px' }}
              onClick={() => setShowLeftPanel(!showLeftPanel)} />
          }
          {location && location.pathname.includes('/equipement/') &&
            <MyButton className="classic-button" type="button" href="#" iconCenter={{ icon: faChevronLeft, type: 'fontAwesome' }}
              styleCss={{ boxShadow: 'none', color: '#FFFFFF', backgroundColor: '#0094ca', width: '20px', height: '20px' }}
              onClick={() => history.push('/equipements')} />
          }
        </div>

        <div id="bloc-logo-template-mobile-tablette">
          <Link to="/">
            <img id="logo-template" style={{ width: '60px' }} src={logoSanef} alt="logo-sanef" />
          </Link>
        </div>

        <LeftPanel open={showLeftPanel} setOpen={setShowLeftPanel} statutWs={props.wsStatus} logout={logout} />

        {
          isTablet &&
          <div id="bloc-menu-droite">
            <div id="boutons-menu-droite">

              <span className="container-geoloc">
                {
                  geoloc ? <FontAwesomeIcon icon={faLocationCrosshairs} size="lg"/> : <FontAwesomeIcon icon={faBan} size="lg"/>
                }
                <Switch
                  checked={geoloc}
                  onChange={handleSwitchGeoloc}
                  color="primary"
                  id="switch-geoloc"
                />
              </span>

              <span className="container-notif-sound">
                {
                  soundNotif ? <FontAwesomeIcon icon={faBell} size="lg"/> : <FontAwesomeIcon icon={faBellSlash} size="lg"/>
                }
                <Switch
                  checked={soundNotif}
                  onChange={handleSwitchSoundNotif}
                  color="primary"
                  id="switch-sound-notif"
                />
              </span>

              {
                props.wsStatus &&
                <Button type="button" style={{
                  backgroundColor: '#EDF4DA',
                  color: '#89A63A',
                  fontWeight: 'bold',
                  height: '35px',
                  borderRadius: '3px',
                  cursor: 'default',
                }}>
                  <SvgIcon color={'#89a63a'} name={'signal-stream'} size={'40px'} type="solid" />
                  connecté
                </Button>
              }
              {
                !props.wsStatus &&
                <Button type="button" style={{
                  backgroundColor: '#f18d2d40',
                  color: '#b18356',
                  fontWeight: 'bold',
                  height: '35px',
                  padding: '6px 16px',
                  borderRadius: '3px',
                  cursor: 'default',
                }}>
                  <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: '10px' }} />
                  déconnecté
                </Button>
              }

              <MyButton
                type="button"
                href="#"
                iconRight={{ icon: <FontAwesomeIcon icon={faSignOutAlt} style={{ margin: '0 10px' }} /> }}
                styleCss={{
                  marginLeft: '15px',
                  backgroundColor: '#ffffff',
                  color: '#505A6E',
                  fontWeight: 'bold',
                  padding: '6px 0px',
                  borderRadius: '3px',
                  border: '1px solid #DCE1E6',
                  width: '30px',
                }}
                onClick={() => handleLogout()}
              />
            </div>
          </div>
        }
        {
          isMobileOnly &&
          <div id="bloc-menu-droite">
            <div id="boutons-menu-droite">

            <span className="container-geoloc">
              {
                geoloc ? <FontAwesomeIcon icon={faLocationCrosshairs} size="lg"/> : <FontAwesomeIcon icon={faBan} size="lg"/>
              }
              <Switch
                checked={geoloc}
                onChange={handleSwitchGeoloc}
                color="primary"
                id="switch-geoloc"
              />
            </span>

              <span className="container-notif-sound">
                {
                  soundNotif ? <FontAwesomeIcon icon={faBell} size="lg"/> : <FontAwesomeIcon icon={faBellSlash} size="lg"/>
                }
                <Switch
                  checked={soundNotif}
                  onChange={handleSwitchSoundNotif}
                  color="primary"
                  id="switch-sound-notif"
                />
              </span>

              {
                props.wsStatus &&
                <Button type="button" style={{
                  backgroundColor: '#EDF4DA',
                  color: '#89A63A',
                  fontWeight: 'bold',
                  height: '35px',
                  borderRadius: '3px',
                  cursor: 'default',
                }}>
                  <SvgIcon color={'#89a63a'} name={'signal-stream'} size={'40px'} type="solid" />
                </Button>
              }
              {
                !props.wsStatus &&
                <Button type="button" style={{
                  backgroundColor: '#f18d2d40',
                  color: '#b18356',
                  fontWeight: 'bold',
                  height: '35px',
                  padding: '6px 16px',
                  borderRadius: '3px',
                  cursor: 'default',
                }}>
                  <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: '10px' }} />
                </Button>
              }

              <MyButton
                type="button"
                href="#"
                iconRight={{ icon: <FontAwesomeIcon icon={faSignOutAlt} style={{ margin: '0 10px' }} /> }}
                styleCss={{
                  marginLeft: '15px',
                  backgroundColor: '#ffffff',
                  color: '#505A6E',
                  fontWeight: 'bold',
                  padding: '6px 0px',
                  borderRadius: '3px',
                  border: '1px solid #DCE1E6',
                  width: '30px',
                }}
                onClick={() => handleLogout()}
              />
            </div>
          </div>
        }


      </div>
    );
  }

  return (
    <div id="topbar">

      <div id="bloc-logo-template">
        <div id="line-rose" />
        <Link to="/">
          <img id="logo-template" src={logoSanef} alt="logo-sanef" />
        </Link>
        <div className="copyright-version">v {packageJson.version}</div>
      </div>

      {
        auth.authenticated &&
        <div id="menu">
          <Link className="menu-entry" to="/equipements">
            {location && location.pathname.includes('/equipements') && <div className="menu-line menu-line-blue" />}
            <div className="menu-text">équipements</div>
          </Link>
          {
            (auth.profil === 1 || auth.profil === 2) &&
            <>
              <Link className="menu-entry" to="/utilisateurs">
                {location && location.pathname.includes('/utilisateurs') && <div className="menu-line menu-line-blue" />}
                <div className="menu-text">Utilisateurs</div>
              </Link>
              <div style={{ display: 'flex', fontFamily: 'Gadugi, sans-serif', textTransform: 'uppercase', alignItems: 'center' }}>
                {location && location.pathname.includes('/parametres') && <div className="menu-line menu-line-blue" />}
                <Button
                  className="buttonHoverMenu"
                  ref={anchorRef}
                  aria-controls={open ? 'menu-list-grow' : undefined}
                  aria-haspopup="true"
                  onClick={handleToggle}
                  style={{
                    color: '#323c46',
                    fontWeight: '600',
                    textDecoration: 'none',
                    textAlign: 'center',
                    fontSize: '1vw',
                    cursor: 'pointer',
                    width: '10vw',
                  }}>
                  Paramètres
                  <i className="fas fa-sort-down" style={{ marginLeft: '10px' }} />
                </Button>
                <Popper open={showSubMenu} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList autoFocusItem={showSubMenu} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                            <MenuItem onClick={() => history.push('/parametres/gestion-indice-gravite')} style={{ fontWeight: '600', fontSize: '0.8vw' }}>Gestion des indices de gravité</MenuItem>
                            <MenuItem onClick={() => history.push('/parametres/gestion-motif-acquittement')} style={{ fontWeight: '600', fontSize: '0.8vw' }}>Gestion des motifs d'acquittement</MenuItem>
                            <MenuItem onClick={() => history.push('/parametres/gestion-commandes-references')} style={{ fontWeight: '600', fontSize: '0.8vw' }}>Gestion des commandes</MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
            </>
          }
        </div>
      }

      <div id="bloc-menu-droite">
        <div id="boutons-menu-droite">

          <span className="container-notif-sound">
            {
              soundNotif ? <FontAwesomeIcon icon={faBell} size="lg"/> : <FontAwesomeIcon icon={faBellSlash} size="lg"/>
            }
            <Switch
              checked={soundNotif}
              onChange={handleSwitchSoundNotif}
              color="primary"
              id="switch-sound-notif"
            />
          </span>

          {
            props.wsStatus &&
            <Button type="button" style={{
              backgroundColor: '#EDF4DA',
              color: '#89A63A',
              fontWeight: 'bold',
              height: '35px',
              borderRadius: '3px',
              cursor: 'default',
              fontSize: '1vw'
            }}>
              <SvgIcon color={'#89a63a'} name={'signal-stream'} size={'40px'} type="solid" />
              connecté au websocket
            </Button>
          }
          {
            !props.wsStatus &&
            <Button type="button" style={{
              backgroundColor: '#f18d2d40',
              color: '#b18356',
              fontWeight: 'bold',
              height: '35px',
              padding: '6px 16px',
              borderRadius: '3px',
              cursor: 'default',
              fontSize: '1vw'
            }}>
              <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: '10px' }} />
              déconnecté
            </Button>
          }
          {
            auth.authenticated &&
            <Button
              href="#"
              type="button"
              style={{ marginLeft: '15px', color: '#505A6E', fontSize: '1vw', fontWeight: 'bold', height: '35px', padding: '10px', borderRadius: '3px', boxShadow: '0px 2px 5px 0px #919b91bb' }}
              onClick={() => handleLogout()} >
              Déconnexion <FontAwesomeIcon icon={faSignOutAlt} style={{ marginLeft: '10px' }} />
            </Button>
          }

        </div>
      </div>

    </div>
  );
};

export default Header;
